import { render, staticRenderFns } from "./listed-securities.vue?vue&type=template&id=034c9844"
import script from "./listed-securities.vue?vue&type=script&lang=js"
export * from "./listed-securities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./listed-securities.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,FauxTabs: require('/vercel/path0/components/FauxTabs.vue').default})
